import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Typography from '../../atoms/typography';
import Button from '../../atoms/button';
import ProductPropertyTab from '../mobile-paid-product-detail-accordion';
import { useProduct } from '../../utils/context/product-provider';
import { logAmplitude } from '../../utils/amplitude';

const ParagraphText = styled(Typography)`
  strong {
    font-weight: bold ;
  }

  ul {
    list-style-type: disc;
    margin: 1rem 0 0 1.75rem;
  }
`;

const Descriptions = styled.div`
  color: ${(props) => props.theme.color.bluePrimary};
  line-height: ${({ theme }) => theme.modularScale.twentyFour};

  ${ParagraphText} + ${ParagraphText} {
    margin-top: ${({ theme }) => theme.modularScale.sixteen};
  }
`;

const FullProductDetailsButton = styled(Button)`
  margin-top: ${({ theme }) => theme.modularScale.sixteen};
  color: ${({ theme }) => theme.color.bluePrimary};
  border: 0.1rem solid ${({ theme }) => theme.color.bluePrimary};
  font-size: ${({ theme }) => theme.modularScale.sixteen};
  line-height: ${({ theme }) => theme.modularScale.twentyFour};
  letter-spacing: 0.2rem;
  max-height: unset;
  height: ${({ theme }) => theme.modularScale.fortyEight};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MobilePaidProductDescription = (props) => {
  const {
    setCtxIsMWebPaidPdpExperience
  } = useProduct();

  const onFullProductDetailsClick = () => {
    setCtxIsMWebPaidPdpExperience(false);
    logAmplitude('PDP Interaction', {
      product: props.product,
      position: '-',
      interactionType: 'Full Product Details Clicked',
    });
  };

  return (
  <>
    <ProductPropertyTab
      title="Description"
      product={props.product}
      isDescription
    >
      <Descriptions>
        {/* TODO: handle dangerouslySetInnerHTML a different way */}
        <ParagraphText
          data-vwo-id="MobilePaidProductDescription"
          element="p"
          like="dec-4"
          dangerouslySetInnerHTML={{ __html: props.description }}
        />

        {
          props.brandDescription && (
            <ParagraphText
              data-vwo-id="MobilePaidBrandDescription"
              element="p"
              like="dec-4"
            >
              {`About ${props.brand}: ${props.brandDescription}`}
            </ParagraphText>
          )
        }

        {props.finalSale && (
          <ParagraphText
            data-vwo-id="MobilePaidFinalSale"
            element="p"
            like="dec-4"
          >
            Final sale - no returns.
          </ParagraphText>
          )
        }
      </Descriptions>
    </ProductPropertyTab>
      <FullProductDetailsButton
        data-vwo-id="MobilePaidFullProductDetailsButton"
        type="button"
        isLink
        outline
        onClick={onFullProductDetailsClick}
      >
        Full Product Details
      </FullProductDetailsButton>
  </>
);
}

MobilePaidProductDescription.defaultProps = {
  brand: '',
  description: '',
  brandDescription: '',
  finalSale: false
};

MobilePaidProductDescription.propTypes = {
  description: PropTypes.string,
  brand: PropTypes.string,
  brandDescription: PropTypes.string,
  product: PropTypes.object.isRequired,
  finalSale: PropTypes.bool
};

export default MobilePaidProductDescription;
